import { useDayPicker } from 'react-day-picker';

/** Represent the props for the {@link DayContent} component. */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Render the content of the day cell.
 */
/** Render the content of the day cell. */
export function CustomDayPickerDayContent(props) {
  const {
    locale,
    classNames,
    styles,
    labels: {
      labelDay
    },
    formatters: {
      formatDay
    }
  } = useDayPicker();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "aria-hidden": "true",
      children: formatDay(props.date, {
        locale
      })
    }), /*#__PURE__*/_jsx("span", {
      className: classNames.vhidden,
      style: styles.vhidden,
      children: labelDay(props.date, props.activeModifiers, {
        locale
      })
    })]
  });
}